<dialog #dialog class="modal" data-testid="modal" (click)="onBackdropClick($event)" (cancel)="onCancelEsc($event)">
  <div class="panel" role="document">
    @if (title() || showCloseIcon()) {
      <header class="header">
        @if (title()) {
          <h2 class="title typography-large-medium" data-testid="modal-title">{{ title() | translate }}</h2>
        }
        @if (showCloseIcon()) {
          <button
            type="button"
            class="close"
            data-testid="modal-close-icon"
            [attr.aria-label]="'CLOSE' | translate"
            (click)="closeAndCancel()"
          >
            <app-icon path="assets/img/close.svg" [size]="20" />
          </button>
        }
      </header>
    }

    <div class="body typography-body-regular" data-testid="modal-body">
      <ng-content></ng-content>
    </div>

    @if (hasActionButtons()) {
      <footer class="actions" data-testid="modal-actions">
        @if (showCancel()) {
          <button
            app-button
            variant="muted"
            data-testid="modal-cancel"
            [disabled]="cancelDisabled()"
            (click)="closeAndCancel()"
          >
            {{ cancelLabel() | translate }}
          </button>
        }
        @if (showConfirm()) {
          <span
            [class.confirm-tooltip-trigger]="confirmHint()"
            [attr.tabindex]="confirmHint() ? 0 : null"
            [attr.aria-label]="confirmHint() ? (confirmLabel() | translate) : null"
            [attr.aria-disabled]="confirmHint() ? true : null"
            (mouseenter)="setConfirmHintVisible(true)"
            (mouseleave)="setConfirmHintVisible(false)"
            (focusin)="setConfirmHintVisible(true)"
            (focusout)="setConfirmHintVisible(false)"
          >
            <button
              app-button
              variant="primary"
              data-testid="modal-confirm"
              [disabled]="confirmDisabled()"
              [loading]="confirmLoading()"
              (click)="onConfirm()"
            >
              {{ confirmLabel() | translate }}
            </button>
          </span>
        }
      </footer>
    } @else {
      <footer class="custom-footer" data-testid="modal-custom-footer">
        <ng-content select="[modalFooter]"></ng-content>
      </footer>
    }
  </div>
</dialog>
